module.exports = __webpack_public_path__ + "498e7a721803c6888e308bdbd44cff7c.png";